import { createSelector } from "reselect";

const selectProductState = (state) => state.products;

export const selectProductList = createSelector(
  [selectProductState],
  (products) => products.productsList
);

export const selectProductGroup = createSelector(
  [selectProductState],
  (products) => products.productsGroups
);

export const selectProductGroupPending = createSelector(
  [selectProductState],
  (products) => products.productGroupPending
);

export const selectProductCategory = createSelector(
  [selectProductState],
  (products) => products.productsCategory
);

export const selectProductCategoryPending = createSelector(
  [selectProductState],
  (products) => products.productCategoryPending
);

export const selectProductBrand = createSelector(
  [selectProductState],
  (products) => products.brands
);

export const selectSuppliers = createSelector(
  [selectProductState],
  (products) => products.suppliers
);

export const selectTotalCount = createSelector(
  [selectProductState],
  (products) => products.totalCount
);

export const selectProductGroupTotalCount = createSelector(
  [selectProductState],
  (products) => products.productGroupTotal
);

export const selectAssortment = createSelector(
  [selectProductState],
  (products) => products.assortments
);

export const selectVatRates = createSelector(
  [selectProductState],
  (products) => products.vatRates
);

export const selectProductPriority = createSelector(
  [selectProductState],
  (products) => products.priorityGroups
);

export const selectProductCountry = createSelector(
  [selectProductState],
  (products) => products.productCountries
);

export const selectCompanyTypes = createSelector(
  [selectProductState],
  (products) => products.companyTypes
);

export const selectCurrencies = createSelector(
  [selectProductState],
  (products) => products.currencies
);

export const selectSupplierType = createSelector(
  [selectProductState],
  (products) => products.supplierTypes
);

export const selectGroupIndented = createSelector(
  [selectProductState],
  (products) => products.productGroupsIndented
);

export const selectCategoriesIndented = createSelector(
  [selectProductState],
  (products) => products.productCategoryIndented
);
